import { render, staticRenderFns } from "./PainelErrosComprometimentosDash.vue?vue&type=template&id=11cae8f0"
import script from "./PainelErrosComprometimentosDash.vue?vue&type=script&lang=js"
export * from "./PainelErrosComprometimentosDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports